/**
 * A global namespace for 'animationDuration' string.
 */
const animationDuration = "animationDuration";
export default animationDuration;
